<template>
  <div class="allocation-storehouse-audit-orders-container">
    <ds-page-header :title="$t('allocationStorehouseAuditOrders.page.title')" :subtitle="$t('allocationStorehouseAuditOrders.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('allocationStorehouseAuditOrders.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="queryAuditOrders">
          {{ $t('allocationStorehouseAuditOrders.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :total="pagination.total" :density="density" :show-column-setting="false" :show-refresh="true"
        @update:density="density = $event" @refresh="queryAuditOrders">
        <template #left><span class="ds-panel__title">{{ $t('allocationStorehouseAuditOrders.title') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="allocationStorehouseAuditOrdersInfo.auditOrders" :loading="loading" :error="hasError"
        :error-message="errorMessage" :density="density" border
        :empty-description="$t('allocationStorehouseAuditOrders.page.empty')" @retry="queryAuditOrders">
        <el-table-column prop="applyId" :label="$t('allocationStorehouseAuditOrders.scheduleNo')" align="center" min-width="140">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="applyCount" :label="$t('allocationStorehouseAuditOrders.allocationCount')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyCount }}</span></template>
        </el-table-column>
        <el-table-column prop="startUserName" :label="$t('allocationStorehouseAuditOrders.applicant')" align="center" min-width="100" />
        <el-table-column prop="stateName" :label="$t('allocationStorehouseAuditOrders.status')" align="center" width="110">
          <template slot-scope="scope"><ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('allocationStorehouseAuditOrders.time')" align="center" width="170">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('allocationStorehouseAuditOrders.operation')" align="center" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="toDetail(scope.row)">{{ $t('allocationStorehouseAuditOrders.view') }}</el-button>
            <el-button size="mini" v-if="scope.row.startUserId === allocationStorehouseAuditOrdersInfo.currentUserId" @click="openEditPurchaseModel(scope.row)">{{ $t('allocationStorehouseAuditOrders.edit') }}</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.curTaskName === '仓库管理员'" @click="allocationStorehouseEnter(scope.row)">{{ $t('allocationStorehouseAuditOrders.allocation') }}</el-button>
            <el-button size="mini" type="success" v-else @click="openAuditOrderModel(scope.row)">{{ $t('allocationStorehouseAuditOrders.approve') }}</el-button>
          </template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="pagination.currentPage" :size="pagination.pageSize" :total="pagination.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { listAllocationStoreAuditOrders, listWorkflowStepStaffs } from '@/api/resource/allocationStorehouseAuditOrdersApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AllocationStorehouseAuditOrdersList',
  components: { DsPageHeader, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      communityId: '',
      allocationStorehouseAuditOrdersInfo: {
        auditOrders: [],
        currentUserId: '',
        conditions: { AuditOrdersId: '', userName: '', auditLink: '', page: 1, row: 10 },
        procure: false,
        audit: '1'
      },
      pagination: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.allocationStorehouseAuditOrdersInfo.currentUserId = getUserId()
    this.listAuditOrders()
    this.loadStepStaff()
  },
  methods: {
    async listAuditOrders() {
      this.loading = true
      try {
        this.hasError = false
        const params = { ...this.allocationStorehouseAuditOrdersInfo.conditions, communityId: this.communityId }
        const res = await listAllocationStoreAuditOrders(params)
        this.allocationStorehouseAuditOrdersInfo.auditOrders = res.data
        this.pagination.total = res.total
      } catch (error) {
        console.error('获取审核订单列表失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },
    async loadStepStaff() {
      try {
        const params = { page: 1, row: 1, staffId: this.allocationStorehouseAuditOrdersInfo.currentUserId, staffRole: '3003', requestType: 'allocationHandle' }
        const res = await listWorkflowStepStaffs(params)
        if (res.data.length > 0) {
          this.allocationStorehouseAuditOrdersInfo.procure = true
        }
      } catch (error) {
        console.error('获取步骤员工失败:', error)
      }
    },
    queryAuditOrders() {
      this.pagination.currentPage = 1
      this.listAuditOrders()
    },
    openAuditOrderModel(auditOrder) {
      this.$router.push({ path: '/pages/common/allocationStorehouseDetail', query: { applyId: auditOrder.applyId, action: 'audit', taskId: auditOrder.taskId, flowId: auditOrder.flowId } })
    },
    openEditPurchaseModel(auditOrder) {
      this.$router.push({ path: '/pages/resource/editAllocationStorehouseApply', query: { applyId: auditOrder.applyId } })
    },
    allocationStorehouseEnter(auditOrder) {
      this.$router.push({ path: '/pages/resource/allocationStorehouseEnter', query: { applyId: auditOrder.applyId, taskId: auditOrder.taskId } })
    },
    toDetail(item) {
      this.$router.push({ path: '/pages/common/allocationStorehouseDetail', query: { applyId: item.applyId } })
    },
    goBack() {
      this.$router.go(-1)
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.allocationStorehouseAuditOrdersInfo.conditions.row = val
      this.listAuditOrders()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.allocationStorehouseAuditOrdersInfo.conditions.page = val
      this.listAuditOrders()
    }
  }
}
</script>

<style lang="scss" scoped>
.allocation-storehouse-audit-orders-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
</style>
